import React from "react";
import { X } from "lucide-react";

interface ModalHeaderProps {
  title: string;
  onClose: () => void;
  icon?: React.ReactNode;
  padding?: "p-4" | "p-6";
  description?: string;
}

const ModalHeader: React.FC<ModalHeaderProps> = ({
  title,
  onClose,
  icon,
  padding = "p-6",
  description,
}) => {
  return (
    <div
      className={`flex shrink-0 items-start justify-between gap-3 border-b ${padding}`}
    >
      <div className="min-w-0 flex items-start gap-2">
        {icon}
        <div className="min-w-0">
          <h3 className="text-lg font-semibold text-neutral-900">{title}</h3>
          {description ? (
            <p className="mt-0.5 text-sm text-neutral-500">{description}</p>
          ) : null}
        </div>
      </div>
      <button
        type="button"
        onClick={onClose}
        className="shrink-0 rounded-lg p-1 text-neutral-400 hover:bg-neutral-100 hover:text-neutral-600"
      >
        <X size={20} />
      </button>
    </div>
  );
};

export default ModalHeader;
